<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Career - Job List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="careerCreate()"
                >Create</CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow>
              <CCol sm="12">
                <CSelect
                  :options="options"
                  class="mr-2"
                  required
                  placeholder="Select By"
                  @change="handleSearchBy"
                />
              </CCol>
            </CRow>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Input text"
                    @input="searchCareer($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="rowClicked(data.item.career_id)"
                    >Edit</CButton
                  >
                  <CButton
                    color="danger"
                    class="mb-0 mr-0"
                    @click="updateCandidate(data.item.career_id)"
                    >Delete</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchCareer('', 'REFRESH')"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="searchCareer('', 'BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
              class="pagination-btn-next"
              @click="searchCareer('', 'NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "Job",
  data() {
    return {
      items: [],
      fields: [
        { key: "career_id", label: "ID" },
        { key: "division_name", label: "Divisi" },
        { key: "job_position", label: "Posisi" },
        { key: "city", label: "Kota" },
        { key: "status", label: "Status" },
        { key: "employment_type", label: "Tipe", _style: "width: 135px;" },
        { key: "action", label: "Action", _style: "width: 150px;" },
      ],
      careerData: {
        status: "INACTIVE",
      },
      searchBy: "",
      searchParameter: "",
      options: ["Division Name", "City", "Employment Type", "Position"],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchBy = "Division Name";
    axios
      .get(`${this.domain}/v1/career/data`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // JSON responses are automatically parsed.
        this.items = response.data.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    refreshTable() {
      axios
        .get(`${this.domain}/v1/career/data`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.items = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateCandidate(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .put(`${this.domain}/v1/career/${item}`, this.careerData, {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // JSON responses are automatically parsed.
              Swal.fire({
                icon: "success",
                title: `Career Deleted ` + response.data.success,
                showConfirmButton: false,
                timer: 2000,
              });
              this.refreshTable();
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Some Data Is missing or invalid",
              });
              console.log(err);
            });
        }
      });
    },
    handleSearchBy(event) {
      this.searchBy = event.target.value;
    },
    searchCareer(event, action) {
      if (this.searchBy === "Division Name") {
        this.searchParameter = "&division_name=" + event;
      } else if (this.searchBy === "City") {
        this.searchParameter = "&city=" + event;
      } else if (this.searchBy === "Employment Type") {
        this.searchParameter = "&employment_type=" + event;
      } else if (this.searchBy === "Position") {
        this.searchParameter = "&position=" + event;
      }

      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/career/data?page=${this.activePage}&per_page=20${this.searchParameter}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    rowClicked(item) {
      this.$router.push({ path: `/career/job/detail/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    careerCreate() {
      this.$router.push({ path: `/career/job/create` });
    },
  },
};
</script>

<style scoped>
@import url("./Job.css");
</style>
